import { InviteCollaborators } from '@/pages/SessionPage/internal/gallery/modes/Invite'
import { Card } from '../../Card'
import { CardHeader } from '../../CardHeader'
import SendIcon from '@/CustomIcons/SendIcon'

export function InviteSection() {
    return (
        <Card className="flex flex-col gap-[40px]">
            <CardHeader icon={SendIcon} title="Session Invitation" />
            <InviteCollaborators />
        </Card>
    )
}
